/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
class e{constructor(e,r,t,o,s,l){this.spatialReference=e,this.layer=r,this.resourceController=t,this._getFeatureStore=o,this.hasZ=s,this.hasM=l}get scheduler(){return this.resourceController.scheduler}get memoryController(){return this.resourceController.memoryController}get featureStore(){return this._getFeatureStore()}}export{e as QueryEngineContext};
